import React from 'react';
import './PortfolioItem.css';

import { FaPlus } from 'react-icons/fa';
import { Link } from 'react-router-dom';



const PortfolioItem = (props) => {  
 
  // Destructuring props
  const { id, image, title, category, popup, portfolio, className } = props;
 
  return (
    <div className={`portfolio-item ${className}`} key={id}>

      <div className="portfolio-content">
  
        {/* Portfolio image */} 
        <img src={image} alt={title} /> 
  
        {/* Portfolio Content */} 
        <div className='content'> 

          <div className='text'>
            {/* Portfolio Category */}
            <p>{category}</p>

            {/* Link to the individual Portfolio Page */}
            <Link
              to={{
                pathname: '/Portfolio/' + title,
              }}
              state={portfolio} >
              <h3>{title}</h3> {/* Portfolio Title */}
            </Link>
          </div>

          
          {/* Trigger popup function */}
          <a className='view' onClick={() => {popup(id)}}><FaPlus className='icon' /></a>  


        </div>

      </div>

    </div>
  ) 

}

export default PortfolioItem;